import { getPoranaytteetByTarkastuskohdeV2, getTestitV2, getTestiCaptionV2 } from '../../../api/api';

// v2 counterpart of RenderVetolujuusBlock.js. Styling constants below are a
// deliberate copy (not imported) — v1's PDF output stays untouched. No
// Rakenneosa column (matches v1's exact column layout, per an explicit
// decision — even though v2's live-editor table now spans multiple
// rakenneosa and does show one there).

const TYYPPI = 'Veto';

const TH = { font: 'Lato', fontSize: 8, bold: true, color: '#fff', fillColor: '#04aa00', alignment: 'center' };

function fmtNum(v, d = 2) {
  if (v === null || v === undefined || v === '') return '—';
  const n = parseFloat(v);
  return isNaN(n) ? '—' : n.toFixed(d);
}

function fmtDepth(row) {
  const f = row.murtosyvyysFrom;
  const t = row.murtosyvyysTo;
  const type = row.murtosyvyysType ?? 'up';
  if (!f && !t) return '—';
  if (!t) return `${type} ${f}`;
  return `${type} ${f} – ${t}`;
}

const headerRow = [
  { text: 'Tunnus',             ...TH },
  { text: 'Ø mm',               ...TH },
  { text: 'Vetolujuus\nMN/m²',  ...TH },
  { text: 'Murtosyvyys\nmm',    ...TH },
  { text: 'Murtotapa',          ...TH },
  { text: 'Lisähuomiot',        ...TH },
];

const TD = (text) => ({ text, font: 'Lato', fontSize: 8, alignment: 'center' });
const layout = {
  hLineWidth: () => 0.5, vLineWidth: () => 0.5,
  hLineColor: () => '#adb5bd', vLineColor: () => '#adb5bd',
  paddingLeft: () => 3, paddingRight: () => 3,
  paddingTop: () => 3, paddingBottom: () => 3,
  fillColor: (row) => row === 0 ? '#04aa00' : (row % 2 === 0 ? '#f8f9fa' : null),
};

export async function renderVetolujuusBlockV2({ block, content, tableCounter }) {
  const nav = block?.data?.nav ?? {};
  if (!nav.tkId) return;

  let samples;
  try { samples = (await getPoranaytteetByTarkastuskohdeV2(nav.tkId)).data ?? []; }
  catch (e) { console.warn('[RenderVetolujuusBlockV2] failed to fetch poränäytteet:', e); return; }

  const eligible = samples.filter(s => (s.testi || '').toLowerCase().includes(TYYPPI.toLowerCase()));
  if (!eligible.length) return;

  const allRows = (await Promise.all(eligible.map(async s => {
    let testit;
    try { testit = (await getTestitV2(s.id)).data ?? []; } catch { return null; }
    const t = testit.find(x => x.tyyppi === TYYPPI);
    if (!t) return null;
    return { tunnus: s.nayte_tunnus, ...t.arvo };
  }))).filter(Boolean);
  if (!allRows.length) return;

  const tblNum = tableCounter ? ++tableCounter.value : null;
  const bodyRows = allRows.map(row => [
    TD(row.tunnus || '—'),
    TD(row.diameter ? String(row.diameter) : '—'),
    TD(fmtNum(row.vetolujuus)),
    TD(fmtDepth(row)),
    TD(row.murtotapa || '—'),
    TD(row.lisahuomiot || ''),
  ]);

  // testi_caption is one per (tarkastuskohde, tyyppi), shared by every
  // sample row in this table — see testi_caption on the backend. Rich-text
  // captions (TaulukkoFooter) are persisted as JSON.stringify({value, html});
  // a bare string (pre-rich-text data) passes through unchanged.
  const readCap = (raw) => {
    if (!raw) return '';
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && 'value' in parsed) return (parsed.value ?? '').trim();
    } catch { /* plain string */ }
    return String(raw).trim();
  };
  let captionRow;
  try { captionRow = (await getTestiCaptionV2(nav.tkId, TYYPPI)).data; } catch { /* fall back below */ }
  // No fallback — an empty caption stays empty in the PDF. The table
  // number still always shows.
  const captionText = readCap(captionRow?.caption);

  content.push({
    stack: [
      { table: { headerRows: 1, widths: [42, 28, 46, 54, '*', '*'], body: [headerRow, ...bodyRows] }, layout, margin: [0, 5, 0, 0] },
      ...(tblNum !== null ? [{
        text: captionText
          ? [{ text: `Taulukko ${tblNum}. `, bold: true }, { text: captionText, bold: false }]
          : [{ text: `Taulukko ${tblNum}.`, bold: true }],
        font: 'Lato', fontSize: 9,
        margin: [0, 4, 0, 0],
      }] : []),
    ],
    margin: [0, 0, 0, 15],
  });
}
